var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.files.length)?_c('div',{staticClass:"flex flex-row text-[14px] px-[15px] py-[12px] gap-2"},_vm._l((_vm.files),function(item,index){return _c('ItemFile',{key:item.name,attrs:{"item":item,"index":index,"visible-close":true},on:{"close":function($event){return _vm.removeFileByIndex(index)}}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }